import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const growthPromptsStyle = {
  position: 'absolute',
  width: 0,
  height: 0,
  bottom: 0,
  right: 0,
  // Initially hidden to prevent flickering of content
  opacity: 0,
  zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
};